import * as React from 'react';

function SvgPaymentLink(props) {
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={56} height={56} rx={4} fill="#FFF2E8" />
      <path
        d="M29.006 35.14a1.44 1.44 0 010 2.039l-.713.712A7.202 7.202 0 0116 32.801a7.2 7.2 0 012.11-5.092l2.893-2.892a7.2 7.2 0 019.878-.298 1.446 1.446 0 01-.33 2.38 1.445 1.445 0 01-1.59-.22 4.32 4.32 0 00-5.923.176l-2.892 2.889a4.319 4.319 0 106.11 6.108l.713-.713a1.44 1.44 0 012.037 0zm8.888-17.035a7.21 7.21 0 00-10.184 0l-.713.713a1.442 1.442 0 102.04 2.04l.713-.713a4.32 4.32 0 016.11 6.108l-2.893 2.893a4.32 4.32 0 01-5.925.172 1.446 1.446 0 00-2.402 1.164 1.445 1.445 0 00.482.995 7.2 7.2 0 009.875-.291l2.894-2.893a7.207 7.207 0 00.003-10.185v-.003z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgPaymentLink;
